import mixpanel from 'mixpanel-browser';
import { delay, removeUndefined } from 'shared-base';
import { isEmployee, isFirstVisit, isPaying, selectors, store } from './globals';

let enabled = false;

export const track = (event: string, properties: Json & IAnalyticsPayload = {}) => {
  if (!enabled || !mixpanel || !event) return;
  const payload: Json = parsePayload({ ...properties, v2: true });

  if (isEmployee) {
    payload.isEmployee = true;
  }

  if (isPaying) {
    payload.paying = true;
  }

  if (!isFirstVisit) {
    payload.returning = true;
  }

  // console.log('track | event, payload =>', event, payload);
  log(event, payload);
  mixpanel.track(event, payload);
};

export const setEnabled = (value: boolean) => {
  enabled = value;
};

export const parsePayload = (payload: IAnalyticsPayload = {}) => {
  const output = removeUndefined({ ...payload });
  const { selectorId } = output;

  try {
    if (selectorId) {
      const state = store.getState();
      const selector = selectors[selectorId];

      if (!selector) {
        throw new Error(`Selector not found: ${selectorId}`);
      }

      const selectorOutput = selector(state);
      Object.assign(output, selectorOutput);
    }
  } catch (err) {
    console.log('parsePayload err =>', err);
  }

  return output;
};

export const log = (eventName: string, payload: IAnalyticsPayload) => {
  try {
    const dom = document.querySelector<HTMLTextAreaElement>('textarea.analytics-log');
    if (!dom) return;
    dom.value = JSON.stringify({ eventName, payload }, null, 2);
  } catch (err) {}
};

export const startExperiment = async (name: string, variant: string) => {
  await delay(150);

  track('$experiment_started', {
    'Experiment name': name,
    'Variant name': variant,
  });

  track(`Experiment ${name}`, { variant });
};
